import * as R from 'ramda'

export function setPostReadMore(state, action) {
  const { postId, readMore } = action.payload

  return R.mergeDeepRight(state, { [postId]: { readMore } })
}
